import { render, staticRenderFns } from "./PopularServiceComponent.vue?vue&type=template&id=b4d5b2d8"
import script from "./PopularServiceComponent.vue?vue&type=script&lang=js"
export * from "./PopularServiceComponent.vue?vue&type=script&lang=js"
import style0 from "./PopularServiceComponent.vue?vue&type=style&index=0&id=b4d5b2d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports